export default __webpack_public_path__ + "static/media/cart.5e840cf9.png";